import React, { useEffect, useState } from 'react';
import { Card, Select } from 'antd';
import { fetchData } from '../../service/dataServices';
import Pie from '../../../components/Chart/Pie/Pie';

const {Option} = Select;

const convertCamelCaseToSentence = (text) => {
  if (text) {
    const result = text.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  }
  return "";
};

const options = [
  'classification',
  'category',
  'region',
  'location',
  'locationArea',
];


function PieCard(props) {

  const [data, setData] = useState([]);
  const [total, setTotal] = useState();
  const [ddType, setDdType] = useState('classification');

  const { isLoading } = fetchData('/api/dashboard/object-dropdowns', data => {
    setData(data);
    setTotal(data.reduce((pre, now) => now.y + pre, 0));
  }, { groupBy: ddType });

  const handleChange = (val) => {
    console.log("val", val);
    setDdType(val);
  }

  return (
    <Card
      loading={isLoading}
      title='Object Field Statistics'
      headStyle={{ color:'#00000073', fontSize: '14px' }}
      extra={
      <Select defaultValue="classification" style={{ width: 220 }} onChange={handleChange}>
        {options.map(option =>
          <Option value={option}>{convertCamelCaseToSentence(option)}</Option>,
        )}
      </Select>
    }>

      <Pie
        hasLegend
        subTitle={convertCamelCaseToSentence(ddType)}
        total={total}
        data={data}
        valueFormat={value => {
          return value;
        }}
        height={500}
        lineWidth={4}
      />


    </Card>
  );
}

export default PieCard;
